import { Component } from '@eppendorf/vnls-device-service-utils';

import { parseBoolean } from '$features/monitoring/monitoring.utils';
import { hasThresholdValue } from '$features/monitoring/monitoring.utils.snapshot';
import {
  ThresholdsFormProfile,
  ThresholdsFormDefaultValues,
} from '$features/monitoring/parameters/thresholds-form/thresholds-form-profile';

export function mapAlertThresholdsToFormValuesSnapshot(
  shadowComp: Component,
): ThresholdsFormProfile {
  return {
    alertHigh: hasThresholdValue(shadowComp.alertThreshold?.high)
      ? `${shadowComp.alertThreshold?.high}`
      : ThresholdsFormDefaultValues.alertHigh,
    alertLow: hasThresholdValue(shadowComp.alertThreshold?.low)
      ? `${shadowComp.alertThreshold?.low}`
      : ThresholdsFormDefaultValues.alertLow,
    warnHigh: hasThresholdValue(shadowComp.warnThreshold?.high)
      ? `${shadowComp.warnThreshold?.high}`
      : ThresholdsFormDefaultValues.warnHigh,
    warnLow: hasThresholdValue(shadowComp.warnThreshold?.low)
      ? `${shadowComp.warnThreshold?.low}`
      : ThresholdsFormDefaultValues.warnLow,
    active:
      parseBoolean(`${shadowComp.alertingEnabled}`) ?? ThresholdsFormDefaultValues.active,
  };
}
